import React from "react";
import "./ourPortfolio.css";
import { useNavigate } from "react-router-dom";
import { useSpring, animated } from "react-spring";
import { useEffect, useRef, useState } from "react";
import { useInView } from "react-intersection-observer";
const OurPortfolio = (props) => {
  const isInPage = props.isInPage;
  const navigate = useNavigate();
  const t = props.language;

  const { ref: descriptionRef, inView: descriptionRefIsVisible } = useInView();
  const { ref: portfolioRef, inView: portfolioIsvisible } = useInView();

  useEffect(() => {}, [portfolioIsvisible]);

  const Number = ({ n }) => {
    const { number } = useSpring({
      from: { number: 0 },
      number: n,
      delay: 200,
      config: { mass: 1, tension: 20, friction: 10 },
    });
    return <animated.div>{number.to((n) => n.toFixed(0))}</animated.div>;
  };

  return (
    <div
      className="big__port"
      style={
        isInPage
          ? { backgroundColor: "whitesmoke" }
          : { backgroundColor: "white" }
      }
    >
      {isInPage ? (
        <div className="team__div" style={{ backgroundColor: "whitesmoke" }}>
          <div className="text__team">
            {t("our_portfolio")}
            <span className="line__team"></span>
          </div>
          <div className="team__desc--wrap">
            <p className="team__desc">{t("portfolio_text")}</p>
          </div>
        </div>
      ) : (
        <div></div>
      )}

      <div
        className="main__portfolio"
        style={isInPage ? { height: "50vh" } : { heigh: "100vh" }}
      >
        {!isInPage ? (
          <>
            <div
              className="team__div"
              style={
                isInPage
                  ? { backgroundColor: "whitesmoke" }
                  : {
                      backgroundColor: "transparent",
                      position: "relative",
                      top: "0rem",
                    }
              }
            >
              <div className="text__team">
                {t("our_portfolio")}
                <span className="line__team"></span>
              </div>
              <div className="team__desc--wrap">
                <p className="team__desc" style={{ color: "white" }}>
                  {t("portfolio_text")}
                </p>
              </div>
            </div>
          </>
        ) : (
          <div></div>
        )}

        <div className="portfolio" ref={portfolioRef}>
          <div className="port1">
            <div className="port__circle">
              <div className="port__wrap">
                <h1>€{!isInPage ? <Number n={250} /> : "250"}M</h1>
                <span> {t("portfolio_1")}</span>
              </div>
            </div>
          </div>
          <div className="port2">
            <div className="port__circle">
              <div className="port__wrap">
                <h1>
                  {!isInPage ? (
                    <h1>
                      <Number n={31} />
                      <h1 style={{ marginLeft: "-20px", fontWeight: "bold" }}>
                        000
                      </h1>
                    </h1>
                  ) : (
                    "31 000"
                  )}
                  <span>{t("mesure")}</span>
                </h1>
                <span> {t("portfolio_2")}</span>
              </div>
            </div>
          </div>
          <div className="port3">
            <div className="port__circle">
              <div className="port__wrap">
                <h1>{!isInPage ? <Number n={57} /> : "57"}+</h1>
                <span> {t("portfolio_3")}</span>
              </div>
            </div>
          </div>
          <div className="port4">
            <div className="port__circle">
              <div className="port__wrap">
                <h1>{!isInPage ? <Number n={5} /> : "5"}+</h1>

                <span> {t("portfolio_4")}</span>
              </div>
            </div>
          </div>
        </div>
        {!isInPage ? (
          <div
            className="invest-btn imp"
            // style={{ color: "white" }}
            onClick={() => {
              navigate("/our-portfolio");
            }}
          >
            {t("dm")}
          </div>
        ) : (
          <div></div>
        )}
      </div>
    </div>
  );
};

export default OurPortfolio;
